<template>
  <div class="sorting">
    <div class="filters"><a href="" @click.prevent="openFilters"><span class="fi-rr-settings-sliders"></span> Filtrer</a></div>
    <div class="total" v-if="!load"><p>{{ totalResults }} téléphones</p></div>
    <div class="dropdowns" v-if="!load">

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Sorting',
  props: {
    payload: Object
  },
  data () {
    return {
      numberOfProducts: [
        { value: 8, name: '10 Produits' },
        { value: 20, name: '20 Produits' },
        { value: 30, name: '30 Produits' },
        { value: 50, name: '50 Produits' },
      ]
    }
  },
  computed: {
    ...mapState({
      phones: state => state.products.items,
      load: state => state.products.loading
    }),
    totalResults () {
      let total = 0
      if(this.phones && this.phones.length) total = this.phones[0].totalCount
      return total
    }
  },
  methods: {
    ...mapActions('products', ['openFilters'])
  }
}
</script>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.sorting{
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 0 30px;
  min-height: 40px;

  @include responsive(mobile) {
    display: block;
    padding: 0 20px;
  }

  .total{
    display: flex;
    align-items: center;
    justify-content: center;

    @include responsive(mobile) {
      display: none;
    }
  }

  .filters{
    display: none;

    @include responsive(mobile) {
      display: block;
    }

    a{
      display: inline-block;
      height: 40px;
      padding: 0 20px;
      line-height: 40px;
      background-color: darken($white, 10%);
      color: $black;
      @include radius(20px);

      span{
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        font-size: 18px;
        @include transform(translateY(-1px));
      }
    }
  }
}
</style>
